import { render, staticRenderFns } from "./gift-rule-list.vue?vue&type=template&id=3dfaad35&scoped=true"
import script from "./gift-rule-list.vue?vue&type=script&lang=js"
export * from "./gift-rule-list.vue?vue&type=script&lang=js"
import style0 from "./gift-rule-list.vue?vue&type=style&index=0&id=3dfaad35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfaad35",
  null
  
)

export default component.exports